import {DomainObject} from 'shared/store';
import {action, observable} from 'mobx';

class InterviewSchedule extends DomainObject {
  @observable templateName;
  @observable resolvedStartDate;
  @observable resolvedEndDate;

  @action merge(other) {
    super.merge(other, {
      _dates: ['resolvedStartDate', 'resolvedEndDate']
    });
  }
}

export default InterviewSchedule;
